import React from 'react';
import { EnhancedSelect } from '../../agencies/quotes/250/EnhancedSelect';
import { updateDocument } from '../../../api/DocumentsService';
import useNotifications from '../../../_lib/notifications/useNotifications';
import classes from './DoctypeDropdown.module.css';

// components

export const DoctypeDropdown = ({ docTypes, data, disabled }: any) => {
  const notifications = useNotifications();
  const { id, docName, docType, fileType } = data;
  const [value, setValue] = React.useState(docType);
  const handleSelectDocType = React.useCallback(
    (event: any) => {
      setValue(event.target.value);
      const payload = {
        docId: id,
        docName,
        docType: event.target.value,
        fileType: fileType?.toUpperCase(),
      };
      updateDocument({}, { ...payload })
        .then(() => {
          notifications.success('Doc type updated successfully!');
        })
        .catch(() => {
          notifications.error('Failed to update doc type!');
        });
    },
    [docName, notifications, fileType, id]
  );

  const curValue = React.useMemo(() => {
    return docTypes.map((option: any) => option.value).includes(docType)
      ? value
      : -1;
  }, [docType, docTypes, value]);

  return (
    <section
      className={classes.dropdown}
      style={{
        float: 'left',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <EnhancedSelect
        required
        variant="naked"
        coverage={{ default: true }}
        options={[{ value: -1, label: 'Please Select' }, ...docTypes]}
        onChange={handleSelectDocType}
        value={curValue}
        data-qa="docType"
        disabled={disabled}
        onClick={(event: any) => event.stopPropagation()}
        style={{
          width: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      />
    </section>
  );
};
